class BaseCookieConsentManager {
    sendSelectedValues(onSuccess) {
        EventBus.getInstance().dispatchEvent('showGlobalSpinner');
        fetch(this.prepareAndReturnApiEndpointLink())
            .then(response => response.json())
            .then(response => {
                this.onConsentStored(response);
                onSuccess && onSuccess();
            })
            .catch(error => console.error('Unable to send custom selection (sendSelectedValues)', error));
    }

    prepareAndReturnApiEndpointLink() {
    }

    onConsentStored(response) {
        EventBus.getInstance().dispatchEvent('hideGlobalSpinner');
        if (response.result) {
            EventBus.getInstance().dispatchEvent('cookiesConsentStored', {consent: response.consent});
            window.cookieConsent = response.consent;
        }
    }
}

class FormCookieConsentManager extends BaseCookieConsentManager {
    formAction;
    data;

    constructor(
        formAction,
        data,
    ) {
        super();
        this.formAction = formAction;
        this.data = data;
    }

    prepareAndReturnApiEndpointLink() {
        const params = new URLSearchParams();
        this.data.forEach((e, i) => params.append(i, e.toString()));
        params.set('redirect', '0');
        return this.formAction + "?" + params.toString();
    }

}

class LinkCookieConsentManager extends BaseCookieConsentManager {
    link;

    constructor(link) {
        super();
        this.link = link;
    }

    prepareAndReturnApiEndpointLink() {
        return this.link + '&redirect=0';
    }

}
